import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import { TaiwanDiscountImportPayload } from '../../../models/parking/taiwan-discount.model';

@Injectable({ providedIn: 'root' })
export class ApiTaiwanDiscountService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getTaiwanDiscountForTable(params: {
    page?: number;
    pageSize?: number;
    searchText?: string;
    active?: boolean | null;
    isOnline?: boolean | null;
  }): Observable<unknown> {
    const query: Record<string, string | number | boolean> = {
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 20,
    };
    if (params.searchText) query['searchText'] = params.searchText;
    if (params.active != null) query['active'] = params.active;
    if (params.isOnline != null) query['isOnline'] = params.isOnline;
    return this.apiMethodService.request('/SystemSettings/getTaiwanDiscountForTable', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getTaiwanDiscountForTable',
      token: this.token,
      headerOnly: false,
      params: query,
    });
  }

  previewTaiwanDiscountFromApi(page = 1, pageSize = 10): Observable<unknown> {
    return this.apiMethodService.request('/SystemSettings/previewTaiwanDiscountFromApi', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'previewTaiwanDiscountFromApi',
      token: this.token,
      headerOnly: false,
      params: { page, pageSize },
    });
  }

  insertTaiwanDiscountFromPreview(body: TaiwanDiscountImportPayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/SystemSettings/insertTaiwanDiscountFromPreview', 'POST', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'insertTaiwanDiscountFromPreview',
      token: this.token,
      headerOnly: false,
      body,
    });
  }

  updateTaiwanDiscountFromPreview(body: TaiwanDiscountImportPayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/SystemSettings/updateTaiwanDiscountFromPreview', 'POST', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'updateTaiwanDiscountFromPreview',
      token: this.token,
      headerOnly: false,
      body,
    });
  }
}
